// extracted by mini-css-extract-plugin
export var box = "preview-module--box--a19d9";
export var footer = "preview-module--footer--db5a7";
export var galleryScroll = "preview-module--galleryScroll--9bbf2";
export var galleryWrapper = "preview-module--galleryWrapper--d7857";
export var header = "preview-module--header--8213f";
export var item = "preview-module--item--08034";
export var itemContent = "preview-module--itemContent--62c0d";
export var layoutContainer = "preview-module--layoutContainer--dfc08";
export var leftbar = "preview-module--leftbar--8df61";
export var main = "preview-module--main--2a765";
export var menuTitle = "preview-module--menuTitle--7ecb2";
export var rightbar = "preview-module--rightbar--2faa4";
export var transform = "preview-module--transform--0b63a";